module.exports = __webpack_public_path__ + "static/media/hand_lettered_mural_concept_for_historic_office_building_2019.96521c3d.webp";